"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Wrapper = _styledComponents["default"].span.withConfig({
  displayName: "IconWrapper__Wrapper",
  componentId: "sc-16usrgb-0"
})(["display:flex;", ""], function (_ref) {
  var $buttonSize = _ref.$buttonSize,
    $position = _ref.$position;
  return (0, _styledComponents.css)(["", " ", ""], $position === 'leading' && (0, _styledComponents.css)(["margin-inline-end:", ";"], _index.buttonWithIconMargin[$buttonSize]), $position === 'trailing' && (0, _styledComponents.css)(["margin-inline-start:", ";"], _index.buttonWithIconMargin[$buttonSize]));
});
var IconWrapper = exports.IconWrapper = function IconWrapper(_ref2) {
  var position = _ref2.position,
    buttonSize = _ref2.buttonSize,
    icon = _ref2.icon,
    iconSize = _ref2.iconSize;
  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    $position: position,
    $buttonSize: buttonSize,
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: iconSize
  }));
};